import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import BreadcrumbsBg from "../Assets/img/breadcrumbs-bg.png";
import BanglaBookImg from "../Assets/img/class-book/bangla-book.jpg";
import EnglishBookImg from "../Assets/img/class-book/english-book.jpg";
import MathBookImg from "../Assets/img/class-book/math-book.jpg";
import BiologyBookImg from "../Assets/img/class-book/biology-book.png";
import AccountingBookImg from "../Assets/img/class-book/accounting-book.jpg";
import ScienceBookImg from "../Assets/img/class-book/science-book.jpg";
import HigherMathBookImg from "../Assets/img/class-book/higher-math-book.jpg";
import ArtCraftBookImg from "../Assets/img/class-book/art-craft-book.jpg";

const ClassBook = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section
        className="eschool-breadcrumbs"
        style={{ backgroundImage: `url(${BreadcrumbsBg})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
              <div className="eschool-breadcrumbs-content">
                <h3 className="eschool-bread-cont-title">Class Book</h3>
                <ul className="eschool-bread-menu">
                  <li>
                    <Link to="/">Home</Link>
                    <i class="fi fi-br-angle-right"></i>
                  </li>
                  <li>
                    <Link to="/classbook">Academic Curriculum</Link>
                    <i class="fi fi-br-angle-right"></i>
                  </li>
                  <li className="active">
                    <Link to="/classbook">Class Book</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="eschool-class-book">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-xl-3 col-12">
              {/* <!-- Tab Menu --> */}
              <div className="class-book-tab-menu">
                <div className="list-group" id="list-tab" role="tablist">
                  <a
                    className="list-group-item active"
                    data-bs-toggle="list"
                    href="#class-9-10"
                    role="tab"
                  >
                    Class Nice-Ten
                  </a>
                  <a
                    className="list-group-item"
                    data-bs-toggle="list"
                    href="#class-8"
                    role="tab"
                  >
                    Class Eight
                  </a>
                  <a
                    className="list-group-item"
                    data-bs-toggle="list"
                    href="#class-7"
                    role="tab"
                  >
                    Class Seven
                  </a>
                  <a
                    className="list-group-item"
                    data-bs-toggle="list"
                    href="#class-6"
                    role="tab"
                  >
                    Class Six
                  </a>
                  <a
                    className="list-group-item"
                    data-bs-toggle="list"
                    href="#class-5"
                    role="tab"
                  >
                    Class Five
                  </a>
                  <a
                    className="list-group-item"
                    data-bs-toggle="list"
                    href="#class-4"
                    role="tab"
                  >
                    Class Four
                  </a>
                  <a
                    className="list-group-item"
                    data-bs-toggle="list"
                    href="#class-3"
                    role="tab"
                  >
                    Class Three
                  </a>
                  <a
                    className="list-group-item"
                    data-bs-toggle="list"
                    href="#class-2"
                    role="tab"
                  >
                    Class Two
                  </a>
                  <a
                    className="list-group-item"
                    data-bs-toggle="list"
                    href="#class-1"
                    role="tab"
                  >
                    Class One
                  </a>
                </div>
              </div>
            </div>
            <div className="col-lg-8 col-xl-9 col-12">
              {/* <!-- Tab Details --> */}
              <div className="class-book-tab-details">
                <div className="tab-content" id="nav-tabContent">
                  {/* <!-- Tab One --> */}
                  <div
                    className="tab-pane fade show active"
                    id="class-9-10"
                    role="tabpanel"
                  >
                    <div className="row">
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={EnglishBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              English
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={MathBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Match
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BiologyBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Biology
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={AccountingBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Acoounting
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={ScienceBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Science
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={HigherMathBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Higher Math
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={ArtCraftBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Arts & Craft
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Tab Two --> */}
                  <div className="tab-pane fade" id="class-8" role="tabpanel">
                    <div className="row">
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={EnglishBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              English
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={MathBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Match
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BiologyBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Biology
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={AccountingBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Acoounting
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={ScienceBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Science
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={HigherMathBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Higher Math
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={ArtCraftBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Arts & Craft
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Tab Three --> */}
                  <div className="tab-pane fade" id="class-7" role="tabpanel">
                    <div className="row">
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={EnglishBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              English
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={MathBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Match
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BiologyBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Biology
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={AccountingBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Acoounting
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={ScienceBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Science
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={HigherMathBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Higher Math
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={ArtCraftBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Arts & Craft
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Tab Four --> */}
                  <div className="tab-pane fade" id="class-6" role="tabpanel">
                    <div className="row">
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={EnglishBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              English
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={MathBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Match
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BiologyBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Biology
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={AccountingBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Acoounting
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={ScienceBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Science
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={HigherMathBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Higher Math
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={ArtCraftBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Arts & Craft
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Tab Five --> */}
                  <div className="tab-pane fade" id="class-5" role="tabpanel">
                    <div className="row">
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={EnglishBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              English
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={MathBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Match
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BiologyBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Biology
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={AccountingBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Acoounting
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={ScienceBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Science
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={HigherMathBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Higher Math
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={ArtCraftBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Arts & Craft
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Tab Six --> */}
                  <div className="tab-pane fade" id="class-4" role="tabpanel">
                    <div className="row">
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={EnglishBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              English
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={MathBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Match
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BiologyBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Biology
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={AccountingBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Acoounting
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={ScienceBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Science
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={HigherMathBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Higher Math
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={ArtCraftBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Arts & Craft
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Tab Seven --> */}
                  <div className="tab-pane fade" id="class-3" role="tabpanel">
                    <div className="row">
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={EnglishBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              English
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={MathBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Match
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BiologyBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Biology
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={AccountingBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Acoounting
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={ScienceBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Science
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={HigherMathBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Higher Math
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={ArtCraftBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Arts & Craft
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Tab Eight --> */}
                  <div className="tab-pane fade" id="class-2" role="tabpanel">
                    <div className="row">
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={EnglishBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              English
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={MathBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Match
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BiologyBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Biology
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={AccountingBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Acoounting
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={ScienceBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Science
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={HigherMathBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Higher Math
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={ArtCraftBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Arts & Craft
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <!-- Tab Nice --> */}
                  <div className="tab-pane fade" id="class-1" role="tabpanel">
                    <div className="row">
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={EnglishBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              English
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={MathBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Match
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BiologyBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Biology
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={AccountingBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Acoounting
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={ScienceBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Science
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={HigherMathBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Higher Math
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={ArtCraftBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Arts & Craft
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6 col-xl-3 col-md-4 col-12">
                        <div className="class-book-card-single">
                          <div className="class-book-card-icon">
                            <img src={BanglaBookImg} alt="#" />
                          </div>
                          <div className="class-book-card-content">
                            <h4 className="class-book-card-cont-title">
                              Bangla 1st paper
                            </h4>
                            <div className="class-book-card-btn">
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single view-btn"
                              >
                                View
                              </a>
                              <a
                                href="JSON/publicFile/Holiday Notice.pdf"
                                target="_blank"
                                className="btn-single dowload-btn"
                                download
                              >
                                Download
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- End Tab Details --> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ClassBook;
